module.exports = __webpack_public_path__ + "static/media/NABScript.ced3a594.woff";